import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=ce80e58a&scoped=true&"
import script from "./PersonModal.vue?vue&type=script&lang=js&"
export * from "./PersonModal.vue?vue&type=script&lang=js&"
import style0 from "./PersonModal.vue?vue&type=style&index=0&id=ce80e58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce80e58a",
  null
  
)

export default component.exports